import React from 'react'
import { Typography } from 'antd'

const { Title } = Typography

export const ContentfulRenderHeading = (toc: { id: string; text: string; level: number }[]) => {
  return (level: 1 | 2 | 3) => (node: any, children: any) => {
    const text = node.content?.[0]?.value || `heading-${level}`
    const id = text.toLowerCase().replace(/\s+/g, '-')
    toc.push({ id, text, level })

    return (
      <Title level={level} id={id}>
        {children}
      </Title>
    )
  }
}
